export default function SouthAsiaCountry() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-50 to-blue-50 py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-navy-900 mb-4">
            South Asia Nursing Pathways
          </h1>
          <p className="text-xl text-slate-600">
            Pakistan • India • Nepal • Sri Lanka • Bangladesh
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          {/* Summary */}
          <div className="mb-12">
            <p className="text-lg text-slate-700 leading-relaxed">
              <strong>Summary:</strong> NCLEX + English (IELTS/OET/TOEFL) for U.S./Canada routes; CGFNS where required; NMC (CBT/OSCE) for the UK.
              See timelines, costs, and recruiter steps on this page.
            </p>
          </div>

          {/* Typical Next Steps */}
          <div className="bg-gray-50 rounded-lg p-8 mb-12">
            <h2 className="text-2xl font-bold text-navy-900 mb-6">Typical next steps</h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <span className="text-teal-600 mr-3 mt-1">✓</span>
                <span className="text-slate-700">Create your Nursing Hive profile (free until Feb 29, 2026)</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-3 mt-1">✓</span>
                <span className="text-slate-700">Pick a route: US (NCLEX/CGFNS), UK (CBT/OSCE), GCC (Dataflow/PSV)</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-3 mt-1">✓</span>
                <span className="text-slate-700">Complete English test (if needed): IELTS/OET/TOEFL</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-3 mt-1">✓</span>
                <span className="text-slate-700">Toggle recruiter visibility when you're ready</span>
              </li>
            </ul>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/register"
              className="px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors text-center"
            >
              Register Free
            </a>
            <a
              href="/resources"
              className="px-8 py-3 border-2 border-slate-300 text-slate-700 font-semibold rounded-lg hover:border-slate-400 hover:bg-slate-50 transition-colors text-center"
            >
              See Resources
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}